/* eslint max-statements: ["error", 20, { "ignoreTopLevelFunctions": true }] */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Form, Card, Grid} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import ConfirmModal from './modal/confirmModal';
import InputSection from './inputSection';
import SaveButton from './saveButton';
import Detail from './detail';
import CleanButton from './cleanButton';
import './specialOrders.scss';
import moment from 'moment';
const INITIALSTATE = {
  'date': moment().format(),
  'reason': '',
  'reasonDescription': '',
  'transport': '',
  'partCode': '',
  'partQuantity': 1,
  'orderRepair': '',
  'comment': '',
  'warranty': false,
  'stopVeh': false,
  'newVeh': false,
  'chassis': '',
  'comentNecesary': false,
};
class DealerSpecialOrder extends Component {
  constructor(props) {
    super(props);
    this.state = INITIALSTATE;
  }
  
  componentDidMount() {
    const {permissions} = this.props;

    if (!hasAccessPermission(permissions, resources.DealerSpecialOrders, scopes.Create)) {
      this.props.navigateTo(paths.AccessDenied);
    }

    this.props.restoreDealerSpecialOrder();
    this.props.getSpecialOrdersReasons();
    this.props.getAllAgencies();
  }


  handleCleanClick() {
    this.setState(
      INITIALSTATE
    );
  }
  handleParameterChange(event, data) {
    this.setState({...this.state, [data.name]: data.value.toUpperCase()});
  }
  handlePartCodeChange(event, data) {
    this.setState({...this.state, [data.name]: data.value.trim().toUpperCase()});
  }
  handleReasonChange(event, data) {
    const reason = data.options.find((reason) => reason.value === data.value);
    this.setState({...this.state,
      'reason': data.value,
      'reasonDescription': reason.text,
    });
  }
  handleQuantityChange(event, data) {
    if (parseInt(data.value, 10) > 10) {
      this.setState({...this.state, [data.name]: parseInt(data.value, 10), 'comentNecesary': true});
    } else {
      this.setState({...this.state, [data.name]: parseInt(data.value, 10), 'comentNecesary': false});
    }
  }
  handleWarrantyChange(event, data) {
    this.setState({...this.state, [data.name]: data.checked});
  }
  handleAddClick() {
    const {
      date, reason, reasonDescription, transport, partCode, partQuantity, warranty, chassis, comment, orderRepair,
      stopVeh, newVeh,
    } = this.state;
    const {dealer, agency} = this.props;
    if (transport === 'V' && !chassis && reason !== 'LB' && transport === 'V') {
      this.props.addMessageBoxError(
        'Se requiere el VIN (chasis) del vehículo cuando se ha marcado el pedido como garantía'
      );
      return;
    }
    const fields = [reason, transport, partCode, partQuantity, chassis];
    if (reason !== 'LB' && fields.some((field) => !field)) {
      this.props.addMessageBoxError('Por favor verifique que los campos requeridos cuenten con información válida');
      return;
    }
    if (chassis.length !== 17 && reason !== 'LB') {
      this.props.addMessageBoxError('La longitud del campo Vin debe ser de 17 caracteres');
      return;
    }
    const {orderDetail} = this.props;
    const itemExists = orderDetail.find((x) => x.partCode === partCode);
    if (!itemExists) {
      this.props.checkDealerSpecialOrderElement({
        dealer, agency, date, reason, reasonDescription, transport, partCode, partQuantity, warranty, chassis, comment,
        orderRepair, stopVeh, newVeh,
      });
      
      this.setState({...this.state, 'partCode': '', 'partQuantity': 0});
    } else {
      this.props.addMessageBoxError(
        'El código de parte ya se encuentra ingresado en la lista de pedidos.'
      );
    }
  }

  render() {
    const {userAgency} = this.props;

    return (
      <Form className='dealer-special-orders'>
        <Card raised fluid className='order-header'>
          <Grid>
            <Grid.Row className='order-title'>
              <Grid.Column width='12'>
                <h2>Pedidos Especiales - Concesionarios</h2>
                <div className='order-subtitle'>
                  {userAgency.dealerName} | {userAgency.description}
                </div>
              </Grid.Column>
              <Grid.Column width='4' textAlign='right'>
                <SaveButton />
                <CleanButton handleCleanClick={this.handleCleanClick.bind(this)}/>
              </Grid.Column>
            </Grid.Row>
            <InputSection data={this.state} handleParameterChange={this.handleParameterChange.bind(this)}
              handlePartCodeChange={this.handlePartCodeChange.bind(this)}
              handleReasonChange={this.handleReasonChange.bind(this)}
              handleQuantityChange={this.handleQuantityChange.bind(this)}
              handleWarrantyChange={this.handleWarrantyChange.bind(this)}
              handleAddClick = {this.handleAddClick.bind(this)}/>
          </Grid>
        </Card>
        <Detail />
        <ConfirmModal />
      </Form>
    );
  }
}

const mapStateToProps = (state) => {
  const {agencies} = state.dealer;
  const {dealerId, dealerAgency} = state.session;
  const userAgency = agencies.find((agency) => agency.dealerId === dealerId && agency.code === dealerAgency);

  return {
    'permissions': state.session.permissions,
    'userAgency': userAgency || {},
    'orderDetail': state.dealerSpecialOrders.list,
  };
};

const {
  getAllAgencies,
  getSpecialOrdersReasons,
  restoreDealerSpecialOrder,
  navigateTo,
  checkDealerSpecialOrderElement,
  addMessageBoxError,
} = Actions;

export default connect(mapStateToProps, {
  getAllAgencies,
  getSpecialOrdersReasons,
  restoreDealerSpecialOrder,
  navigateTo,
  checkDealerSpecialOrderElement,
  addMessageBoxError,
})(DealerSpecialOrder);
